<template>
    <div>
        <v-form v-model="valid" class="block-reserv-plan py-3">
            <v-container>
                <v-row class="mt-4">
                    <!-- Start Time -->
                    <v-col cols="12" md="5" class="form_label_plan">
                        <v-text-field
                            v-model="form.start"
                            :label="$t('planningModal.startTime') + ' *'"
                            type="time"
                            :rules="[requiredRule, startEndRule]"
                            required
                            append-icon="mdi-clock-outline"
                        ></v-text-field>
                    </v-col>

                    <!-- End Time -->
                    <v-col cols="12" md="5" class="form_label_plan">
                        <v-text-field
                            v-model="form.end"
                            :label="$t('planningModal.endTime') + ' *'"
                            type="time"
                            :rules="[requiredRule, endAfterStartRule]"
                            required
                            append-icon="mdi-clock-outline"
                        ></v-text-field>
                    </v-col>

                    <!-- Active Checkbox -->
                    <v-col cols="12" md="2" class="pt-3 form_label_plan d-flex m-auto check-reserv-plan">
                        <v-checkbox v-model="form.active" :label="$t('common.enabled')" class="mt-lg-3 mt-md-0 pe-6"></v-checkbox>
                    </v-col>

                    <!-- Submit Button -->
                    <v-col cols="12" md="12" class="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                        <!-- Submit Button -->
                        <v-btn color="green" @click="addPeriod" :disabled="!valid" :loading="loading" class="btn-enreg-plan">{{
                            $t('common.save')
                        }}</v-btn>
                        <v-btn color="red" @click="deletePeriod" :loading="loading" class="btn-suppr-plan">{{
                            $t('common.delete')
                        }}</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-alert
                        v-if="log.show"
                        :class="{
                            'alert-msg': true,
                            [log.type]: !!log.type, // ajoute la classe log.type si log.type est défini
                        }"
                        dismissible
                    >
                        {{ log.message }}
                    </v-alert>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>

<script>
import ApiManager from '../Calendar/_core/ApiManager.js'

export default {
    name: 'PrestationReservationPeriod',
    props: {
        period: {
            required: true,
        },
    },
    data() {
        return {
            valid: false,
            form: {
                start: '',
                end: '',
                active: true,
            },
            log: {
                message: '',
                type: '',
                show: false,
            },
            loading: false,
        }
    },

    components: {},

    methods: {
        async addPeriod() {
            this.loading = true
            try {
                const res = await ApiManager.updateReservationPeriod(this.period.id, this.form)
                this.showSuccessMsg(this.$t('planningModal.periodUpdateSuccess'))
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.loading = false
                setTimeout(() => {
                    this.hideLogMsg()
                }, 10000)
            }
        },
        async deletePeriod() {
            this.loading = true
            try {
                const res = await ApiManager.deleteReservationPeriod(this.period.id)
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //this.showErrorMsg("Une erreur s'est produite.")
            } finally {
                this.loading = false
                this.$emit('refreshList')
            }
        },
        showErrorMsg(Msg) {
            this.log.message = Msg
            this.log.type = 'error'
            this.log.show = true
        },
        showSuccessMsg(Msg) {
            this.log.message = Msg
            this.log.type = 'success'
            this.log.show = true
        },
        hideLogMsg() {
            this.log.show = false
        },
        validateStartEnd(value) {
            // Custom validation logic for start time
            console.log('validateStartEnd', this.form.end && value < this.form.end)
            return !this.form.end || (this.form.end && value < this.form.end) || this.$t('planningModal.errorTimeRange')
        },
        validateEndAfterStart(value) {
            // Custom validation logic for end time after start time
            return (this.form.start && value > this.form.start) || this.$t('planningModal.errorTimeRange')
        },
    },
    created() {
        // Fetch available prestations (dummy data for demonstration)
        console.log('period', this.period)
        this.form.active = this.period.active
        this.form.start = this.period.start.substring(0, 5)
        this.form.end = this.period.end.substring(0, 5)
    },
    watch: {
        'form.start': function (newVal) {
            this.validateStartEnd(newVal)
            this.validateEndAfterStart(this.form.end)
        },
        'form.end': function (newVal) {
            this.validateEndAfterStart(newVal)
        },
    },
    computed: {
        requiredRule() {
            return (v) => !!v || this.$t('planningModal.requiredField')
        },
        startEndRule() {
            return (v) => this.validateStartEnd(v)
        },
        endAfterStartRule() {
            return (v) => this.validateEndAfterStart(v)
        },
    },
}
</script>

<style scoped lang="css">
.alert-msg {
    text-align: left;
}
.success {
    color: #021832 !important;
    background: linear-gradient(90deg, rgba(227, 248, 235, 1) 0%, rgba(238, 249, 243, 1) 24%, rgba(255, 255, 255, 1) 100%);
    border-bottom: 6px solid #01e17b !important;
    border: none;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    line-height: 38px;
    max-width: 385px !important;
    z-index: 1;
    font-size: 15px;
}
.error {
    color: #021832 !important;
    background: linear-gradient(90deg, rgba(249, 233, 233, 1) 0%, rgba(249, 235, 236, 1) 24%, rgba(255, 255, 255, 1) 100%);
    border-bottom: 6px solid #de2c2c;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    line-height: 38px;
    max-width: 385px !important;
    z-index: 1;
    right: 15px !important;
}
</style>
